"use client";

import { useEffect, useRef, type ReactNode } from "react";

import { useCcPrefersReducedMotion } from "@/lib/use-cc-prefers-reduced-motion";

/**
 * Writes the hero's scroll progress to `--cc-ls-s` so each floating card
 * can drift at its own depth in CSS (lassie.ai). Nothing else re-renders.
 */
export function CcLsHeroParallax({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const reduced = useCcPrefersReducedMotion();

  useEffect(() => {
    const root = ref.current;
    if (!root || reduced) return;
    let frame = 0;
    const update = () => {
      frame = 0;
      root.style.setProperty("--cc-ls-s", Math.min(1.5, Math.max(0, window.scrollY / window.innerHeight)).toFixed(3));
    };
    const onScroll = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(frame);
    };
  }, [reduced]);

  return (
    <div ref={ref} className="cc-ls-hero__parallax">
      {children}
    </div>
  );
}
